
<template>
  <div class="download-m">
    <div class="download-box">
      <div class="download-info">
        <img src="@/assets/images/logo-app.png" alt="">
        <div class="download-info-info">
          <div>采道App</div>
          <div>
            <span>AI大数据</span>
            <span>模拟试玩</span>
            <span>走势图</span>
            <span>比分直播</span>
          </div>
        </div>
      </div>

      <div class="download-btns">
        <div>
          <a-icon type="android" style="color: #fff;"/>
          <span @click="onDownload('a')">安卓下载</span>
        </div>
        <div>
          <a-icon type="apple" style="color: #fff;"/>
          <span @click="onDownload('i')">IOS入口</span>
        </div>
      </div>

      <!-- <div class="download-preview">
        <div class="download-preview-title">
          预览
        </div>

        <div class="download-preview-images">
          <img v-for="item in 4" :key="item" :src="require(`@/assets/images/preview-${item}.png`)"  alt="">
        </div>
      </div> -->

      <!-- <div class="download-introduce">
        <div class="download-introduce-title">
          简介
        </div>

        <div class="download-introduce-content">
          采道APP是嘉彩科讯开发的为彩票从业者和爱好者服务的一个互联网平台，初心就是在合法合规的情况下帮助彩票店主赚钱，增加彩票店主收益。采道平台以增加彩票店主收入，拓展彩票店主收入渠道为平台的方向发展。当然为彩票店主提供彩票店主帮扶项目、提供彩票店主日常运营所需的各类海报、视频、文案等资源，是采道平台最基本的工作。为彩票爱好者提供赛事资讯和数据服务。
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'download-m',

  methods: {
    onDownload (type) {
      if (this.$tools.isWxBrowser()) {
        console.log('这个不执行')
        location.href = this.$store.state.commonDownloadUrl
        return
      }

      if (type === 'a') {
        location.href = this.$store.state.downloadAppUrl
      } else {
        location.href = this.$store.state.url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.download-m {
  .download-box {
    padding: 40px 15px 47px;

    .download-info {
      margin-bottom: 25px;
      @include flex(row);

      img {
        width: 92px;
        height: 92px;
        margin-right: 15px;
      }

      .download-info-info {
        height: 92px;
        @include flex(col, center);

        div {
          &:nth-child(1) {
            margin-bottom: 20px;
            font-size: 22px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 26px;
          }

          &:nth-child(2) {
            span {
              height: 18px;
              border-radius: 48px;
              margin-right: 4px;
              padding: 2px 5px;
              font-size: 10px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #1769E4;
              line-height: 12px;

              &:nth-child(1) {
                background: rgba(23,105,228,0.08);
                color: #1769E4;
              }

              &:nth-child(2) {
                color: #FF4D00;
                background: rgba(243,82,13,0.08);
              }

              &:nth-child(3) {
                color: #62C812;
                background: rgba(98,200,18,0.08);
              }

              &:nth-child(4) {
                color: #1AD9F3;
                background: rgba(26,217,243,0.08);
              }
            }
          }
        }
      }
    }

    .download-btns {
      margin-bottom: 50px;
      @include flex(row);
      div {
        flex: 1;
        height: 40px;
        background: #0080FF;
        border-radius: 50px;
        @include flex(row, center, center);

        &:nth-child(1) {
          margin-right: 7px;
        }

        span {
          margin-left: 11px;
          font-size: 15px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
        }
      }
    }

    .download-preview {
      margin-bottom: 50px;

      .download-preview-title {
        margin-bottom: 20px;
        font-size: 15px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 18px;
      }

      .download-preview-images {
        @include flex(row);
        width: 100%;
        overflow: scroll;

        img {
          width: 243px;
          flex-shrink: 0;
          margin-right: 13px;
        }
      }
    }

    .download-introduce {
      .download-introduce-title {
        margin-bottom: 20px;
        font-size: 15px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 18px;
      }

      .download-introduce-content {
        font-size: 13px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 35px;
      }
    }
  }
}
</style>
